import useSWR from 'swr';
import { surveyEndService } from '@/services/api';
import { config } from '@/config';
import { AwaitedReturnType, FetchErrorsType } from '@/types';

const API_URL = config.api.url.survey;

export const useSurveyEndQuery = (surveyKey: string | undefined, userId: string | undefined) =>
    useSWR<AwaitedReturnType<typeof surveyEndService.getParticipationSummary>, FetchErrorsType>(
        surveyKey && userId ? [`${API_URL}`, surveyKey, userId] : null,
        ([_, surveyKey, userId]: [_: string, surveyKey: string, userId: string]) =>
            surveyEndService.getParticipationSummary(surveyKey, userId),
        {
            revalidateOnFocus: false,
        },
    );
